import { PAYPAL_SUBSCRIPTION_STATUSES } from '../types/billing';

const PAYPAL_ID_RE = /^[A-Z0-9_-]{6,80}$/;
const PAYPAL_STATUSES = new Set<string>(PAYPAL_SUBSCRIPTION_STATUSES);

export function isSafePayPalPlanId(value: string): boolean {
  return PAYPAL_ID_RE.test(value);
}

export function isSafePayPalSubscriptionId(value: string): boolean {
  return PAYPAL_ID_RE.test(value);
}

export function isRecognizedPayPalSubscriptionStatus(value: string | null): boolean {
  return value !== null && PAYPAL_STATUSES.has(value);
}

export function normalizePayPalSdkLocale(value?: string | null): string | null {
  const locale = value?.trim().toLowerCase().replace('-', '_');
  if (!locale) return null;

  if (locale.startsWith('he')) return 'he_IL';
  if (locale.startsWith('en')) return 'en_US';
  if (locale.startsWith('ar')) return 'ar_EG';
  return null;
}

export function buildPayPalSdkUrl(input: {
  readonly clientId: string;
  readonly currency: 'ILS';
  readonly locale?: string | null;
}): string {
  if (!input.clientId.trim()) {
    throw new Error('PayPal client id is required');
  }

  const url = new URL('https://www.paypal.com/sdk/js');
  url.searchParams.set('client-id', input.clientId);
  url.searchParams.set('components', 'buttons');
  url.searchParams.set('vault', 'true');
  url.searchParams.set('intent', 'subscription');
  url.searchParams.set('currency', input.currency);
  const paypalLocale = normalizePayPalSdkLocale(input.locale);
  if (paypalLocale) url.searchParams.set('locale', paypalLocale);
  return url.toString();
}
